import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class AssignmentService {

  key: string = 'assignment'

  constructor(public hs: HttpService) { }

  async assign_evaluator(value: { assessment_id: number; evaluator_id: number | null; script_ids: number[]; level?: number; evaluation_type?: string }) {
    try {
      return await this.hs.post(`/${this.key}/assign-evaluator`, {}, value);
    } catch (error: any) {
      throw error;
    }
  }

  async get_list(filters: any) {
    try {
      return await this.hs.get(`/${this.key}/get-evaluator-assignment-list`, filters);
    } catch (error: any) {
      throw error;
    }
  }
}
